import { put, takeLatest, fork, call } from "redux-saga/effects";
import { httpStatus } from "configs/httpStatus";
import { fetchClearTempRegister } from "services/classchangemanagement";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./clearTempRegisterActions";
import {
  ActionType,
  IClearTempRegisterData,
} from "models/classchangemanagement/clearTempRegisterClassChange";
import { IResponse } from "models";

function* clearTempRegisterSaga({
  payload,
}: {
  payload: IClearTempRegisterData;
}) {
  try {
    const response: IResponse = yield call(fetchClearTempRegister, payload);
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onClearTempRegisterWatcher() {
  yield takeLatest(
    ActionType.CLEAR_TEMP_REGISTERS as any,
    clearTempRegisterSaga
  );
}

export default [fork(onClearTempRegisterWatcher)];
